/**
 * @module constants
 */

/**
 * @constant
 * An event name for logging telemetry when the transaction action is clicked
 */

export const TRANSACTION_ACTION_CLICKED = 'TransactionActionEvent';

/**
 * @constant
 * A key to access the action context from the Action object
 */

export const ACTION_CONTEXT = 'actionContext';
